// TODO: add video formats back in once we have a way to handle them
export const acceptedMediaTypes = [
  '.mp4',
  '.png',
  '.jpg',
  '.jpeg',
  '.webm',
  '.gif',
];
